(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.DialogController = (function(superClass) {
    extend(DialogController, superClass);

    function DialogController(scope, transitions, modalInstance, state) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.state = state;
      this.goToStep = bind(this.goToStep, this);
      this.includeDuplicates = bind(this.includeDuplicates, this);
      this.next = bind(this.next, this);
      this.canContinue = bind(this.canContinue, this);
      this.previous = bind(this.previous, this);
      this.currentStepIs = bind(this.currentStepIs, this);
      DialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.step = {
        title: '',
        buttonText: 'Next',
        loading: false,
        previous: function() {},
        next: function() {},
        includeDuplicates: function() {},
        canContinue: function() {}
      };
      this.scope.selected = {
        years: [],
        spps: [],
        survey_results: [],
        duplicate_fields: [],
        downloading: false
      };
      this.scope.title = '';
      this.scope.$watch('step.title', (function(_this) {
        return function(title) {
          return _this.scope.title = title;
        };
      })(this));
      this.scope.currentStepIs = this.currentStepIs;
      this.scope.previous = this.previous;
      this.scope.next = this.next;
      this.scope.includeDuplicates = this.includeDuplicates;
      this.scope.canContinue = this.canContinue;
      this.scope.goToStep = this.goToStep;
      this.goToStep('select_year_and_crop');
    }

    DialogController.prototype.currentStepIs = function() {
      var i, len, params, step_name;
      params = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      for (i = 0, len = params.length; i < len; i++) {
        step_name = params[i];
        if (this.state.includes("grower.placement.report." + step_name)) {
          return true;
        }
      }
      return false;
    };

    DialogController.prototype.previous = function() {
      return this.scope.step.previous();
    };

    DialogController.prototype.canContinue = function() {
      if (this.scope.selected.downloading) {
        return false;
      }
      return this.scope.step.canContinue();
    };

    DialogController.prototype.next = function() {
      return this.scope.step.next();
    };

    DialogController.prototype.includeDuplicates = function() {
      return this.scope.step.includeDuplicates();
    };

    DialogController.prototype.goToStep = function(step_name) {
      this.scope.step.includeDuplicates = function() {
        return void 0;
      };
      return this.state.go("grower.placement.report." + step_name, null, {
        location: false
      });
    };

    return DialogController;

  })(DialogController);

}).call(this);
